export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: false,
    link: true,
    emote: true,
    gif: {
        canAlign: false,
        smallMedia: true,
        defaultWidth: 650,
        defaultAlignment: 'center'
    },
    heading: false,
    textAlignment: false,
    deviation: {
        defaultWidth: 212,
        smallMedia: true,
        canAlign: false,
        canResize: false,
        canConfigure: false,
        standaloneLink: true
    },
    deviationThumb: {
        defaultWidth: 150,
        canLink: true,
        maxHeight: 600,
        maxWidth: 780
    },
    daVideo: {
        canAlign: false,
        defaultWidth: 412,
        defaultHeight: 319,
        defaultAlignment: 'center',
        smallMedia: true
    },
    gallery: {
        defaultWidth: 650,
        defaultAlignment: 'center',
        defaultGridItemWidth: 150,
        defaultGridItemHeight: 100,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 100,
        defaultLayoutSpacing: 8,
        canAlign: false,
        canResize: false,
        canLink: false,
        canConfigure: false,
        smallMedia: true
    },
    paste: true,
    history: true,
    allowUploads: true,
    anchor: false,
    spinner: true,
    blockDragging: false,
    blockquote: true,
    mention: true,
    textColor: false,
    textFont: false,
    textHighlight: false,
    indent: false,
    hashtag: true,
    muro: true,
    characterCount: false,
    modEnterSubmit: true
};

//# sourceMappingURL=config.js.map